
import {
    Col,
    Row
} from "react-bootstrap";
import RenderField from "../RenderField";

const Education = ({fields,register,errors}) => {

    return (
        <div className="px-4 pt-8">
            <Row className="">
                <Col md={6}>
                    <RenderField type={'select'} className={'form-control '} label={'Level of Education'} placeholder={'Education'} name={'education'} required={true} values={[
                        { label: "-- select --", value: "" },
                        { label: "High School", value: "High School" },
                        { label: "Bachelor", value: "Bachelor" }, {
                            label: "Masters", value: "Masters",
                        },
                        { label: "PhD", value: "PhD", }
                    ]} register={register} errors={errors} />
                </Col>

                <Col md={6}>
                    <RenderField type={'select'} className={'form-control'} label={'Field of Study'} placeholder={'Study Field'} name={'studyField'} required={true} values={
                          [  { label: "-- select--", value: "" }].concat(fields.map((item) => ({ label: item.label, value: item.label })))} 
                         register={register} errors={errors} />
                </Col>

                <Col md={6} className="mt-1">
                    <RenderField multiline={true} label={'Other special skills or technologies'} size={'small'} required={true} rows={3} className={'form-control mt-2'} name={'otherSkill'} placeholder={'Type here ...'} register={register} errors={errors} maxLength={350}/>
                </Col>

            </Row>
        </div>
    )
}

export default Education